export default __webpack_public_path__ + "static/media/ebloc1.318ab5fd.png";